// This is the current way we initialise our page modules
// All pages should have an entry point that is called from here, to ensure that browser shims have loaded when they are executed

import './search';
